import React, { useEffect, useState } from "react";
import { IFilterCategory } from "../../../../types/category.type";
import FilterText from "../FilterText";
import WrapperFilter from "../WrapperFilter";
import FilterSelectApi from "../FilterSelectApi";

function FilterNhomHang({ setCondition }: IFilterCategory) {
  const originFilter: { [key: string]: any } = {
    ten_nvt: "",
    nhom_me: null,
  };
  const [filter, setFilter] = useState<{ [key: string]: any }>(originFilter);
  const [toggleClear, setToggleClear] = useState<number>(0);

  const refreshFilter = () => {
    setFilter(originFilter);
    setToggleClear(toggleClear + 1);
  };

  useEffect(() => {
    const condition: { [key: string]: any } = {};
    if (filter.ten_nvt) {
      condition.ten_nvt = {
        $regex: filter.ten_nvt?.split(" ").join(".*"),
        $options: "i",
      };
    }
    if (filter.nhom_me) {
      condition.nh_me = filter.nhom_me._id;
    }
    setCondition(condition);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <WrapperFilter refreshFilter={refreshFilter}>
      <FilterText
        direction="column"
        label="Tên nhóm hàng"
        placeholder="Tìm theo tên nhóm hàng"
        value={filter.ten_nvt}
        onSearch={(val) => setFilter({ ...filter, ten_nvt: val })}
      />
      <FilterSelectApi
        direction="column"
        label="Nhóm mẹ"
        placeholder="Chọn nhóm mẹ"
        apiCode="dmnvt"
        searchFields={["ten_nvt"]}
        defaultCondition={{ la_nhom_hang_hoa: true }}
        getOptionLabel={(option) => option.ten_nvt}
        checkEqual={(value, option) => value?._id === option?._id}
        value={filter.nhom_me}
        onChange={(val) => setFilter({ ...filter, nhom_me: val })}
      />
    </WrapperFilter>
  );
}

export default FilterNhomHang;
